import { gql } from '@apollo/client';

export const COMPLETED_TEST_SESSIONS_BY_USER = gql`
  query TestSessions($userId: ID!, $order: String!, $hidden: Boolean, $isCompleted: Boolean!, $showRemoved: Boolean) {
    testSessions(userId: $userId, order: $order, hidden: $hidden, isCompleted: $isCompleted, showRemoved: $showRemoved) {
      id
      rating
      ratingDescription
      completedAt
      feedback
      tester {
        id
        hidden
        testerPayment {
          id
          status
          convertedAmount
        }
        project {
          id
          shareCode
          name
          testType
          company {
            id
            name
          }
        }
      }
    }
    user(userId: $userId) {
      id
      averageRating
      status
      isBannedModeratedAt
      profile {
        id
        firstName
        lastName
        country
      }
    }
  }
`;

export const LAST_EDITION = gql`
  query EditionLocked($userId: ID!) {
    user(userId: $userId) {
      id
      profile {
        editionLocked
      }
    }
  }
`;

export const USER_TRACKINGS = gql`
  query User($userId: ID!) {
    user(userId: $userId) {
      id
      userTrackings {
        id
        ip
        location
        createdAt        
      }
    }
  }
`;

export const HIDE_TESTER = gql`
mutation HideTester($testerId: ID!) {
  hideTester(testerId: $testerId) {
    tester{
      id
      hidden
    }
  }
}
`;

export const DELETE_USER = gql`
  mutation DeleteUser($userId: ID!) {
    deleteUser(userId: $userId) {
      void
    }
  }
`;

export const RESET_RATING_AND_REVIEW = gql`
  mutation ResetRatingAndReview($testSessionId: ID!) {
    resetRatingAndReview(testSessionId: $testSessionId) {
      testSession {
        id
        rating
        ratingDescription
      }
    }
  }
`;

export const WRITE_FEEDBACK = gql`
  mutation WriteFeedback($testSessionId: ID!, $feedback: String!) {
    writeFeedback(testSessionId: $testSessionId, feedback: $feedback) {
      testSession {
        id
        feedback
      }
    }
  }
`;

export const LOCK_PROFILE_EDITION = gql`
  mutation LockProfileEdition($userId: ID!) {
    lockProfileEdition(userId: $userId) {
      profile {
        id
        editionLocked
      }
    }
  }
`;

export const UNLOCK_PROFILE_EDITION = gql`
  mutation UnlockProfileEdition($userId: ID!) {
    unlockProfileEdition(userId: $userId) {
      profile {
        id
        editionLocked
      }
    }
  }
`;

export const UPDATE_COUNTRY = gql`
  mutation UpdateCountry($userId: ID!, $country: String!) {
    updateCountry(userId: $userId, country: $country) {
      profile {
        country
      }
    }
  }
`;

export const GET_TESTER_DATA = gql`
  query User($userId: ID!) {
    user(userId: $userId) {
      email
      profile {
        paypalAccount
      }
      referrals {
        id
        firstName
        lastName
        user {
          id
          testers {
            id
            paymentValue
            project {
              id
              name
              company {
                id
                name
              }
            }
          }
        }
      }
      testers {
        id
        paymentValue
        project {
          id
          name
          description
          testType
          status
          createdAt
          surveys {
            id
            surveyType
            questions {
              id
              label
              questionType
              questionOrder
              questionOptions {
                id
                label
              }
            }
          }
          company {
            id
            name
          }
        }
        testSessions {
          id
          completedAt
          status
        }
        screenerSession {
          id
          authenticationToken
          screenerSessionAnswers {
            id
            questionOptionId
          }
        }
      }
    }
  }
`;
